import { Box, Typography } from '@mui/material'
import { FC } from 'react'

type KanbanTitleProps = {
  stageName: string
  height: number | undefined
  count?: number
  color: string
}

export const KanbanTitle: FC<KanbanTitleProps> = ({
  stageName,
  count,
  color,
  height
}) => {
  return (
    <Box
      className="kanban__title"
      sx={{
        minHeight: `${height}px`,
        minWidth: '200px',
        backgroundColor: color,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '4px',
        padding: '5px 12px'
      }}
      mb={2}
    >
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 'bold',
          wordWrap: 'wrap',
          color: 'white'
        }}
      >
        {stageName} ({count})
      </Typography>
    </Box>
  )
}
